export const Types = {
    TAG: 'tag',
    DIV: 'div',
};